import styled from 'react-emotion';
import { themeGet } from 'styled-system';

export const BaseButton = styled('button')`
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  background: transparent;
`;

export const ActionButton = styled(BaseButton)`
  background: ${themeGet('colors.red')};
  border-radius: 4px;
  font-weight: 700;
  width: 100%;
  height: 40px;
  transition: all 0.15s ease;
  padding: ${themeGet('space.2')}px;
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-1px);
    -moz-transform: none;
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.11), 0 3px 6px rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    transform: none;
    opacity: 0.7;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }
`;

export const FloatingButton = styled(ActionButton)`
  background: #fff;
  border: 1px solid ${themeGet('colors.greyLight')};
  color: ${themeGet('colors.black')};

  &:hover {
    transform: none;
    background-color: ${themeGet('colors.greyLight')};
  }
`;

export const IconButton = styled(BaseButton)`
  width: 40px;
  height: 40px;
  border-radius: 9999999px;
  border: 1px solid transparent;
  transition: background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`;



// WEBPACK FOOTER //
// ./src/components/buttons/style.js